import React, { useEffect } from 'react';
import { useStore } from '../../../../../../stores/root';
import styles from './styles.module.scss';
import { SpinnerSize, Stack } from '@fluentui/react';
import LoadingComponent from '../../../../../feedbacks/loading';
import Label from '../../../../../typography/label';
import GeneralService from '../../../../../../services/general';
import { IIncomeInvoiceResourceShortProps } from '../../../../../../props/finance/incomes/invoices/invoice';

type TotalIncomeInvoiceAmountCardProps = {
    style?: any;
    grow?: number | boolean | "inherit" | "initial" | "unset" | undefined;
    variant?: 'primary' | 'default';
    invoices?: IIncomeInvoiceResourceShortProps[];
}

const TotalIncomeInvoiceAmountCard: React.FC<TotalIncomeInvoiceAmountCardProps> = (props: TotalIncomeInvoiceAmountCardProps) => {
    const { banner } = useStore();
    const [totalAmount, setTotalAmount] = React.useState<number>();

    useEffect(() => {
        calculateTotalAmount();
    }, [props.invoices]);

    const calculateTotalAmount = () => {
        let totalAmount = 0;

        (props.invoices || []).forEach((invoice) => {
            totalAmount += Number(invoice.invoiceAmount || invoice.totalAmount || '0');
        });

        setTotalAmount(totalAmount);
    }

    return <Stack grow={props.grow} tokens={{ childrenGap: 20 }} className={`${styles.card} ${styles.variant}`} style={props.style}>
        <Stack>
            <Label size={'small'}>Total amount</Label>
        </Stack>
        <Stack>
            {!props.invoices ? <LoadingComponent labelPosition='right' label={'Retrieving ...'} spinnerPosition={'baseline'} size={SpinnerSize.small} /> : null}
            {props.invoices ? <>
                <Label className={'color-blue'} size={'large'}>Rp. {GeneralService.getNumberWithSeparator(totalAmount + '')}</Label>
            </> : null}
        </Stack>
    </Stack>;
};

export default TotalIncomeInvoiceAmountCard;
